
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

@Component
export default class PasswordHelpCard extends Vue {
  @Prop(Boolean) public readonly isStudent!: boolean
}
